import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { m } from 'framer-motion';
// @mui
import { Box, Button, Stack, Typography } from '@mui/material';
// components
import { MotionContainer, varBounce } from 'components/animate';
// assets
import { SeverErrorIllustration } from 'assets/illustrations';
import Iconify from 'components/iconify';
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 9998,
  width: '100%',
  height: '100%',
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

AppCustomScreen.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  hideButton: PropTypes.bool,
};

export default function AppCustomScreen({
  title = 'There was an error',
  description = 'Please try again later.',
  hideButton = false,
}) {
  const navigate = useNavigate();
  return (
    <MotionContainer>
      <Stack
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 1,
        }}
      >
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            {title}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>{description}</Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <SeverErrorIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>

        {!hideButton && (
          <Box>
            <Button
              onClick={() => {
                navigate(-1);
              }}
              startIcon={<Iconify icon="icon-park-outline:back" />}
              size="large"
              variant="contained"
            >
              Go Back
            </Button>
          </Box>
        )}
      </Stack>
    </MotionContainer>
  );
}
